import createIcon from '../../createIcon';

/**
 * @component @name KeyboardArrowUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy40MSAxNS43MDQ5TDEyIDExLjEyNDlMMTYuNTkgMTUuNzA0OUwxOCAxNC4yOTQ5TDEyIDguMjk0OTJMNiAxNC4yOTQ5TDcuNDEgMTUuNzA0OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardArrowUp = createIcon('KeyboardArrowUp', [
  [
    'path',
    {
      d: 'M7.41 15.7049L12 11.1249L16.59 15.7049L18 14.2949L12 8.29492L6 14.2949L7.41 15.7049Z',
      key: '1jcnwk',
    },
  ],
]);

export default KeyboardArrowUp;
